import { RouteRecordRaw } from 'vue-router'

// 获取初用户和开发模块的 view component
export function getModuleViewComponents() {
  const components = new Map()

  const importComponents = import.meta.glob(['../views/**/*.vue'])

  for (const k in importComponents) {
    components.set(k.replace('../views', ''), importComponents[k])
  }

  return components
}

// 静态路由基座（两种模式共用）：登录、404 兜底、Layout 容器
// 工作台前端写死，不走动态路由，默认重定向进工作台
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Layout',
    redirect: '/default',
    meta: { title: 'Workbench', icon: 'ep:house', hidden: false },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: 'default',
        name: 'Dashboard',
        component: () => import('@/views/Default/index.vue'),
        meta: { title: '工作台', icon: 'svg:menu-workbench', hidden: false, keepalive: 1, order: 0, type: 1 }
      }
    ]
  }
]

// default routes，通常不会进入左侧菜单（个人中心、固定资产等）
export const defaultRoutes: RouteRecordRaw[] = [
  {
    path: '/profile',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '用户管理',
      hidden: true
    },
    children: [
      {
        path: 'me',
        name: 'profile-me',
        meta: { title: '个人中心', hidden: true },
        component: () => import('@/views/Profile/me.vue')
      }
    ]
  },
  {
    path: '/human-resources',
    component: () => import('@/layout/index.vue'),
    meta: { hidden: true },
    children: [
      {
        path: 'assets/category',
        name: 'fixed-assets-category',
        meta: { title: '固定资产分类', hidden: true },
        component: () => import('@/views/FixedAsset/Category/index.vue')
      },
      {
        path: 'assets/belong',
        name: 'fixed-assets-belong',
        meta: { title: '固定资产归属', hidden: true },
        component: () => import('@/views/FixedAsset/Belong/index.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录', hidden: true },
    component: () => import('@/views/Login/index.vue')
  }
]
